module.exports = __webpack_public_path__ + "static/img/bind_wifiLedStrip.d38ec05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/connect/bind_wifiLedStrip.png
// module id = 751
// module chunks = 1